import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { MedicalProcedureSharedService } from "../services/medical-procedure-shared.service";

@Component({
  selector: "app-procedure",
  templateUrl: "./procedure.component.html",
  styleUrls: ["./procedure.component.scss"],
})
export class ProcedureComponent implements OnInit {
  private readonly defaultCommonMsg = {
    addressHighlight: "Please address the highlighted areas, then try again.",
    alert: "Info",
    dataRequired: "Data required",
    editprocedure: "Please update the procedure which was already in edit",
    examBpAlreadyChoose: "This particular exam and body part is already chosen.",
    fillAll: "Please address the highlighted areas and try again",
    norec: "No records found",
    popupProcedure: "Do you want to remove the procedure?",
    procedureSelected: "The Procedure was already selected",
    procedureUpdateSuccess: "Procedure updated successfully",
    proceduredeleted: "Procedure deleted successfully",
    saveChgs: "Unable to save the changes",
  };
  examList: any;
  alert: any;
  bodyPartsList: any;
  procedureList: any;
  resetProcedureList: any = [];
  selectedlang: any = this.defaultCommonMsg;
  saveProcedureList: any;
  TCProceduresList: any;
  proceduresList: any;
  procedureInfoSubmit = false;
  generalvalidationMessage: any;
  currencyLength: any = 7;
  currencysymbol = environment.symbol[0];
  customCurrencyMaskConfig = {
    align: "right",
    allowNegative: false,
    allowZero: true,
    decimal: "",
    precision: 0,
    prefix: this.currencysymbol,
    suffix: "",
    thousands: ",",
    nullable: true,
  };
  editOpen = false;
  procedureupdatesubmit = false;
  showcptcode = false;
  errorMessage: string;
  Message: any = "";
  apihit = false;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  i = 0;
  popuptype: any = "";
  bp = 0;
  @ViewChild("generalvalidation") generalvalidation: TemplateRef<any>;
  @ViewChild("deletePopup") deletePopup: TemplateRef<any>;

  constructor(
    private appservice: AppService,
    private modalService: BsModalService,
    private supportService: SupportService,
    private router: Router,
    private medicalProcedureShared: MedicalProcedureSharedService
  ) {
    this.examList = [];
    this.bodyPartsList = [];
    this.procedureList = [];
    this.TCProceduresList = [];

    this.proceduresList = [];
  }

  ngOnInit() {
    this.getcountrycodebytc();
    this.getallprocedurebytc();
    this.getallexams();
    this.emptyProcedureList();
    this.getLanguage();

    this.medicalProcedureShared.emitTestCenterAndStateNames(this);
  }

  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res && res["commonMsg"]) {
        this.selectedlang = Object.assign({}, this.defaultCommonMsg, res["commonMsg"]);
      }
    });
  }

  getcountrycodebytc() {
    this.appservice.getcountrycodebytc().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          if (res["entity"]["countryCode"]) {
            this.currencysymbol =
              res["entity"]["countryCode"] === "US"
                ? environment.symbol[0]
                : environment.symbol[1];
            this.currencyLength = res["entity"]["countryCode"] === "IN" ? 8 : 7;
            this.customCurrencyMaskConfig = {
              align: "right",
              allowNegative: false,
              allowZero: true,
              decimal: "",
              precision: 0,
              prefix: this.currencysymbol,
              suffix: "",
              thousands: ",",
              nullable: true,
            };
            if (res["entity"]["countryCode"] === "IN") {
              this.showcptcode = false;
            } else {
              this.showcptcode = true;
            }
          } else {
            this.getCurrentIPAddress();
          }
        } else {
          this.getCurrentIPAddress();
        }
      } else {
        this.getCurrentIPAddress();
      }
    });
  }

  getCurrentIPAddress() {
    this.medicalProcedureShared.getCurrentIPAddress(this);
  }

  getAddressBasedonCurrentIp(ip) {
    this.appservice.getAddressBasedonCurrentIp(ip).subscribe(
      (res) => {
        if (res && res["status"] === "success" && res["countryCode"]) {
          if (res["countryCode"] === "IN") {
            this.showcptcode = false;
          } else {
            this.showcptcode = true;
          }
          this.currencysymbol =
            res["countryCode"] === "US"
              ? environment.symbol[0]
              : environment.symbol[1];
          this.currencyLength = res["countryCode"] === "IN" ? 8 : 7;
          this.customCurrencyMaskConfig = {
            align: "right",
            allowNegative: false,
            allowZero: true,
            decimal: "",
            precision: 0,
            prefix: this.currencysymbol,
            suffix: "",
            thousands: ",",
            nullable: true,
          };
        } else if (
          res &&
          res["status"] === "success" &&
          res["lat"] &&
          res["lon"]
        ) {
          this.getAddressBasedonLatandLng(+res["lat"], +res["lon"], "initial");
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getAddressBasedonLatandLng(latitude, longitude, type) {
    if (latitude && longitude) {
      this.appservice.getAddressFromGoogle(latitude, longitude).subscribe(
        (res) => {
          if (
            res &&
            res["status"] &&
            (res["status"] === "ok" || res["status"] === "OK")
          ) {
            if (res["results"][0]) {
              const firsttime = false;
              if (res["results"][0]["address_components"]) {
                for (
                  let index = 0;
                  index < res["results"][0]["address_components"].length;
                  index++
                ) {
                  if (
                    res["results"][0]["address_components"][index][
                      "types"
                    ][0] === "country"
                  ) {
                    if (
                      res["results"][0]["address_components"][index][
                        "long_name"
                      ] === "India" ||
                      res["results"][0]["address_components"][index][
                        "long_name"
                      ] === "india"
                    ) {
                      this.showcptcode = false;
                    } else {
                      this.showcptcode = true;
                    }
                    this.currencysymbol =
                      res["results"][0]["address_components"][index][
                        "long_name"
                      ] === "India" ||
                      res["results"][0]["address_components"][index][
                        "long_name"
                      ] === "india"
                        ? environment.symbol[1]
                        : environment.symbol[0];
                    this.currencyLength =
                      res["results"][0]["address_components"][index][
                        "long_name"
                      ] === "India" ||
                      res["results"][0]["address_components"][index][
                        "long_name"
                      ] === "india"
                        ? 8
                        : 7;
                    this.customCurrencyMaskConfig = {
                      align: "right",
                      allowNegative: false,
                      allowZero: true,
                      decimal: "",
                      precision: 0,
                      prefix: this.currencysymbol,
                      suffix: "",
                      thousands: ",",
                      nullable: true,
                    };
                  }
                }
              }
            }
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  addProcedure() {
    let valid = true;
    for (let i = 0; i < this.saveProcedureList.length; i++) {
      if (
        this.saveProcedureList[i].duration !== ""
      ) {
        valid = true;
        this.procedureInfoSubmit = false;
      } else {
        valid = false;
        this.procedureInfoSubmit = true;
        break;
      }
    }
    if (valid) {
      this.saveProcedureList.push({
        testCenterId: localStorage.getItem("testCenterId"),
        bodyPartId: "",
        examId: "",
        cptCode: "",
        duration: "",
        amount: "",
        startInd: 0,
        endInd: 0,
      });
    } else {
      this.generalvalidationMessage = this.selectedlang.fillAll;
      this.alert = this.selectedlang.alert;
      this.openModal(this.generalvalidation);
      this.procedureInfoSubmit = true;
    }
  }

  getallprocedurebytc() {
    this.TCProceduresList = [];
    const data = {
      testCenterId: localStorage.getItem("testCenterId"),
    };
    this.appservice.getallprocedurebytc(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.TCProceduresList = res["entity"];
          for (let index = 0; index < this.TCProceduresList.length; index++) {
            this.TCProceduresList[index].disabled = true;
          }
        }
        if (res && res["status"] && res["status"]["status"] === 230) {
          this.Message = "";
          this.errorMessage = this.selectedlang.dataRequired;
        }
        setTimeout(() => {
          this.errorMessage = "";
        }, 5000);
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  cloneProcedure(procedure) {
    return JSON.parse(JSON.stringify(procedure));
  }

  resetSaveProcedure() {
    if (this.resetProcedureList && this.resetProcedureList.length > 0) {
      this.saveProcedureList = [];
      for (let i = 0; i < this.resetProcedureList.length; i++) {
        this.saveProcedureList.push(this.cloneProcedure(this.resetProcedureList[i]));
      }
    } else {
      this.emptyProcedureList();
    }
    this.procedureInfoSubmit = false;
  }

  editInline(i) {
    if (!this.editOpen) {
      this.editOpen = true;
      this.TCProceduresList[i].disabled = false;
    } else {
      this.alert = "Info";
      this.generalvalidationMessage = this.selectedlang.editprocedure;
      this.openModal(this.generalvalidation);
    }
  }

  updateProcedure(i) {
    let valid = false;
    if (
      this.TCProceduresList[i] &&
      this.TCProceduresList[i] !== null &&
      this.TCProceduresList[i].duration !== null &&
      this.TCProceduresList[i].duration !== "" &&
      this.TCProceduresList[i].amount !== null &&
      this.TCProceduresList[i].amount !== ""
    ) {
      valid = true;
    } else {
      valid = false;
      this.generalvalidationMessage = this.selectedlang.addressHighlight;
      this.openModal(this.generalvalidation);
    }
    if (valid) {
      const data = {
        tcProInputs: [
          {
            testCenterId: localStorage.getItem("testCenterId"),
            examId: this.TCProceduresList[i].examId,
            bodyPartId: this.TCProceduresList[i].bodyPartId,
            cptCode: this.TCProceduresList[i].cptCode,
            duration: this.TCProceduresList[i].duration,
            procedureName: this.TCProceduresList[i].procedureName,
            amount: this.TCProceduresList[i].amount,
          },
        ],
      };
      this.appservice.addorupdateprocedure(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.editOpen = false;
            this.procedureupdatesubmit = false;
            this.Message = this.selectedlang.procedureUpdateSuccess;
            this.TCProceduresList[i].disabled = true;
          }
          if (res && res["status"] && res["status"]["status"] === 204) {
            this.Message = "";
            this.errorMessage = this.selectedlang.norec;
          }
          if (res && res["status"] && res["status"]["status"] === 230) {
            this.Message = "";
            this.errorMessage = this.selectedlang.dataRequired;
          }
          setTimeout(() => {
            this.Message = "";
          }, 5000);
        },

        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  getallexams() {
    this.appservice.getAllExamswithTcId().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.examList = res["entity"];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallbodypartsbyexamid(examid, index) {
    const data = {
      examId: examid,
    };
    this.saveProcedureList[index].bodyPartId = "";
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.saveProcedureList[index].bodyPartsList = res["entity"];
        }
        if (res && res["status"] && res["status"]["status"] === 204) {
          this.Message = "";
          this.errorMessage = this.selectedlang.norec;
        }
        if (res && res["status"] && res["status"]["status"] === 230) {
          this.Message = "";
          this.errorMessage = this.selectedlang.dataRequired;
        }
        setTimeout(() => {
          this.Message = "";
        }, 5000);
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  emptyProcedureListExamId(examId) {
    this.saveProcedureList = [];
    this.saveProcedureList.push({
      testCenterId: localStorage.getItem("testCenterId"),
      bodyPartId: "",
      examId: examId,
      cptCode: "",
      duration: "",
      amount: "",
      startInd: 0,
      endInd: 0,
    });
  }

  emptyProcedureList() {
    this.saveProcedureList = [];
    this.saveProcedureList.push({
      testCenterId: localStorage.getItem("testCenterId"),
      bodyPartId: "",
      examId: "",
      cptCode: "",
      duration: "",
      amount: "",
      startInd: 0,
      endInd: 0,
    });
  }

  getAmountByCptCode(cptCode) {
    if (this.TCProceduresList && this.TCProceduresList.length > 0) {
      for (let p = 0; p < this.TCProceduresList.length; p++) {
        if (this.TCProceduresList[p].cptCode === cptCode) {
          return this.TCProceduresList[p].amount;
        }
      }
    }
    return "";
  }

  getprocedure(examId, bodypartId, index, bodyPart, bodyindex) {
    if (bodypartId === "all") {
      let isExist = false;
      let p = 0;

      if (this.saveProcedureList && this.saveProcedureList.length > 0) {
        for (let s = 0; s < this.saveProcedureList.length; s++) {
          if (
            index !== s &&
            examId === this.saveProcedureList[s].examId &&
            bodyPart[bodyindex].id === this.saveProcedureList[s].bodyPartId
          ) {
            isExist = true;
            p += 1;
          }

          if (
            this.saveProcedureList &&
            !this.saveProcedureList[s].cptCode &&
            this.saveProcedureList.length > 0
          ) {
            this.saveProcedureList.splice(s, 1);
          }
        }
      }

      if (!isExist) {
        p = 0;
        this.saveProcedureList.push({
          testCenterId: localStorage.getItem("testCenterId"),
          bodyPartId: bodyPart[bodyindex].id,
          bodyPartsList: bodyPart,
          examId: examId,
          cptCode: "",
          duration: "",
          amount: "",
          startInd: 0,
          endInd: 0,
        });
        this.getallproceduresbybodypart(
          examId,
          bodyPart[bodyindex].id,
          index,
          "all",
          bodyindex,
          bodyPart
        );
      } else {
        if (bodyPart.length > bodyindex + 1) {
          this.getprocedure(
            examId,
            "all",
            this.saveProcedureList.length,
            bodyPart,
            bodyindex + 1
          );
        } else {
          if (p > 0) {
            this.generalvalidationMessage = this.selectedlang.examBpAlreadyChoose;
            this.alert = this.selectedlang.alert;
            this.openModal(this.generalvalidation);
            return;
          }
        }
      }
    } else {
      this.getallproceduresbybodypart(
        examId,
        bodypartId,
        index,
        "",
        0,
        bodyPart
      );
    }
  }

  getallproceduresbybodypart(
    examId,
    bodypartId,
    index,
    type,
    bodyindex,
    bodyPart
  ) {
    let isExist = false;
    if (
      this.saveProcedureList &&
      this.saveProcedureList.length > 0 &&
      type === ""
    ) {
      for (let s = 0; s < this.saveProcedureList.length; s++) {
        if (
          index !== s &&
          examId === this.saveProcedureList[s].examId &&
          bodypartId === this.saveProcedureList[s].bodyPartId
        ) {
          isExist = true;
          break;
        }
      }
    }
    if (isExist && type === "") {
      this.saveProcedureList[index].bodyPartId = "";
      this.generalvalidationMessage = this.selectedlang.examBpAlreadyChoose;
      this.alert = this.selectedlang.alert;
      this.openModal(this.generalvalidation);
    } else {
      const data = {
        bodypartId: bodypartId,
      };
      this.appservice.getallproceduresbybodypart(data).subscribe(
        (res) => {
          if (res && res["entity"]) {
            this.procedureList = res["entity"];
            if (
              this.saveProcedureList &&
              this.saveProcedureList.length > 1 &&
              this.saveProcedureList.length > index + 1
            ) {
              this.saveProcedureList.splice(
                this.saveProcedureList[index].startInd + 1,
                this.saveProcedureList[index].endInd
              );
            }

            if (this.procedureList && this.procedureList.length > 0) {
              this.saveProcedureList[index].examId = examId;
              this.saveProcedureList[index].bodyPartId = bodypartId;
              this.saveProcedureList[
                index
              ].procedureName = this.procedureList[0].procedureName;
              this.saveProcedureList[
                index
              ].cptCode = this.procedureList[0].cptCode;
              this.saveProcedureList[
                index
              ].duration = this.procedureList[0].duration;
              this.saveProcedureList[index].amount = this.getAmountByCptCode(
                this.procedureList[0].cptCode
              );
              this.saveProcedureList[index].startInd = index;
              this.saveProcedureList[index].endInd =
                index + (this.procedureList.length - 1);
              this.pushToResetProcedure(this.saveProcedureList[index]);
              for (let i = 1; i < this.procedureList.length; i++) {
                const spl = {
                  testCenterId: this.saveProcedureList[index].testCenterId,
                  examId: this.saveProcedureList[index].examId,
                  bodyPartId: this.saveProcedureList[index].bodyPartId,
                  bodyPartsList: bodyPart,
                  procedureName: this.procedureList[i].procedureName,
                  cptCode: this.procedureList[i].cptCode,
                  duration: this.procedureList[i].duration,
                  amount: this.getAmountByCptCode(
                    this.procedureList[i].cptCode
                  ),
                  startInd: this.saveProcedureList[index].startInd,
                  endInd: this.saveProcedureList[index].endInd,
                };
                this.pushToResetProcedure(spl);
                this.saveProcedureList.splice(index + i, 0, spl);
              }
              if (type === "all" && bodyPart.length > bodyindex + 1) {
                this.getprocedure(
                  examId,
                  "all",
                  this.saveProcedureList.length,
                  bodyPart,
                  bodyindex + 1
                );
              }
            }
          }
          if (res && res["status"] && res["status"]["status"] === 204) {
            this.Message = "";
            this.errorMessage = this.selectedlang.norec;
          }
          if (res && res["status"] && res["status"]["status"] === 230) {
            this.Message = "";
            this.errorMessage = this.selectedlang.dataRequired;
          }
          setTimeout(() => {
            this.Message = "";
          }, 5000);
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  pushToResetProcedure(saveProcedure) {
    let isExist = false;
    if (this.resetProcedureList && this.resetProcedureList.length > 0) {
      for (let r = 0; r < this.resetProcedureList.length; r++) {
        if (this.resetProcedureList[r].cptCode === saveProcedure.cptCode) {
          isExist = true;
          break;
        }
      }
      if (!isExist) {
        this.resetProcedureList.push(this.cloneProcedure(saveProcedure));
      }
    } else {
      this.resetProcedureList.push(this.cloneProcedure(saveProcedure));
    }
  }

  removebeforesaveprocedure(i) {
    if (this.saveProcedureList && this.saveProcedureList.length > 1) {
      this.saveProcedureList.splice(i, 1);
    } else {
      this.emptyProcedureList();
    }
  }

  removeprocedures(i) {
    if (this.TCProceduresList !== null && this.TCProceduresList[i] !== null) {
      const data = {
        id: this.TCProceduresList[i].id,
      };

      this.medicalProcedureShared.removeTcProcedure(this, data, i);
    }
  }

  saveprocedure() {
    let valid = false;
    this.alert = this.selectedlang.saveChgs;
    for (let i = 0; i < this.saveProcedureList.length; i++) {
      if (this.saveProcedureList[i].bodyPartId&&
        this.saveProcedureList[i].examId&&
        this.saveProcedureList[i].procedureName&&
        this.saveProcedureList[i].duration !== "") {
          if(this.showcptcode&&this.saveProcedureList[i].cptCode){
            valid = true;
          }else if(this.showcptcode&&!this.saveProcedureList[i].cptCode){
            valid = false;
            this.generalvalidationMessage = this.selectedlang.addressHighlight;
            break;
          }else{
            valid=true;
          }
      } else {
        valid = false;
        this.generalvalidationMessage = this.selectedlang.addressHighlight;
        break;
      }
    }

    for (let i = 0; i < this.saveProcedureList.length; i++) {
      if (this.saveProcedureList[i].duration !== "") {
       if(this.saveProcedureList[i].amount === ""){
         this.saveProcedureList[i].amount = 0;
       }
      }
    }


    this.procedureInfoSubmit = true;
    if (valid) {
      this.apihit = true;
      const data = {
        tcProInputs: this.saveProcedureList,
      };
      this.appservice.addorupdateprocedure(data).subscribe(
        (res) => {
          const statusCode = res && res["status"] ? res["status"]["status"] : null;
          if (statusCode === 200 || statusCode === "200") {
            this.procedureInfoSubmit = false;
            this.apihit = false;
            this.emptyProcedureList();
            this.getallprocedurebytc();
            this.Message = this.selectedlang.procedureUpdateSuccess;
            if (
              localStorage.getItem("subscriptionflag") !== "true" &&
              localStorage.getItem("testCode")
            ) {
              setTimeout(() => {
                this.router.navigate([
                  localStorage.getItem("testCode").toString().trim(),
                  "insurance",
                ]);
              }, 1500);
            }
          }

          if (statusCode === 230 || statusCode === "230") {
            this.apihit = false;
            this.Message = "";
            this.errorMessage = this.selectedlang.dataRequired;
          }
          if (statusCode !== 200 && statusCode !== "200" && statusCode !== 230 && statusCode !== "230") {
            this.apihit = false;
          }
          setTimeout(() => {
            this.Message = "";
          }, 5000);
        },

        (err) => {
          this.apihit = false;
          this.appservice.sessionOut(err);
        }
      );
    } else {
      this.openModal(this.generalvalidation);
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  scrollTop(value) {
    document.getElementById(value).scrollIntoView();
  }

  editprocedure(p) {
    this.scrollTop("scrollme");
    let flag = 0;
    let startInd = 0;
    let endInd = 0;
    let availableCpt = 0;
    if (
      this.saveProcedureList &&
      this.saveProcedureList.length > 0 &&
      this.saveProcedureList[0].bodyPartId &&
      this.saveProcedureList[0].examId
    ) {
      for (let index = 0; index < this.saveProcedureList.length; index++) {
        if (
          this.saveProcedureList[index].examId === p.examId &&
          this.saveProcedureList[index].bodyPartId === p.bodyPartId
        ) {
          flag = index;
          startInd = this.saveProcedureList[index].startInd;
          endInd = this.saveProcedureList[index].endInd;
          if (this.saveProcedureList[index].cptCode === p.cptCode) {
            this.generalvalidationMessage = this.selectedlang.procedureSelected;
            this.alert = this.selectedlang.alert;
            this.openModal(this.generalvalidation);
            availableCpt = 1;
            this.saveProcedureList[index].duration = p.duration;
            this.saveProcedureList[index].amount = p.amount;
            break;
          }
        }
      }
      if (availableCpt === 0 && flag !== 0) {
        this.saveProcedureList.splice(flag + 1, 0, {
          testCenterId: p.testCenterId,
          bodyPartId: p.bodyPartId,
          examId: p.examId,
          procedureName: p.procedureName,
          cptCode: p.cptCode,
          duration: p.duration,
          amount: p.amount,
          startInd: startInd,
          endInd: endInd + 1,
        });
        this.getallbodypartsbyexamid(p.examId, flag + 1);
      }
      if (availableCpt === 0 && flag === 0) {
        startInd = this.saveProcedureList.length;
        endInd = startInd + 1;
        this.saveProcedureList.push({
          testCenterId: p.testCenterId,
          bodyPartId: p.bodyPartId,
          examId: p.examId,
          procedureName: p.procedureName,
          cptCode: p.cptCode,
          duration: p.duration,
          amount: p.amount,
          startInd: startInd,
          endInd: endInd,
        });
        this.getallbodypartsbyexamid(
          p.examId,
          this.saveProcedureList.length - 1
        );
      }
    } else if (
      this.saveProcedureList &&
      this.saveProcedureList.length > 0 &&
      this.saveProcedureList[0] &&
      (!this.saveProcedureList[0].bodyPartId ||
        !this.saveProcedureList[0].examId)
    ) {
      this.saveProcedureList[0].bodyPartId = p.bodyPartId;
      this.saveProcedureList[0].examId = p.examId;
      this.getallbodypartsbyexamid(p.examId, 0);
      this.saveProcedureList[0].procedureName = p.procedureName;
      this.saveProcedureList[0].cptCode = p.cptCode;
      this.saveProcedureList[0].duration = p.duration;
      this.saveProcedureList[0].amount = p.amount;
      this.saveProcedureList[0].startInd = 0;
      this.saveProcedureList[0].endInd = 1;
    }
  }

  popupConfirmationAfterSave(i) {
    this.i = i;
    this.alert = "Remove";
    this.popuptype = "deleteaftersave";
    this.generalvalidationMessage = this.selectedlang.popupProcedure;
    this.openModal(this.deletePopup);
  }

  popupConfirmationBeforeSave(i) {
    this.i = i;
    this.alert = "Remove";
    this.popuptype = "deletebeforesave";
    this.generalvalidationMessage = this.selectedlang.popupProcedure;
    this.openModal(this.deletePopup);
  }

  triggerPopup() {
    if (this.popuptype === "deleteaftersave") {
      this.removeprocedures(this.i);
    }
    if (this.popuptype === "deletebeforesave") {
      this.removebeforesaveprocedure(this.i);
    }

    document.getElementById("closepopup").click();
  }

  getSaveExamOpacityValue(i, p) {
    if (p && p.examId) {
      if (i !== 0 && this.saveProcedureList[i - 1].examId === p.examId) {
        return 0;
      }
    }
    return 1;
  }

  getSaveBodyOpacityValue(i, p) {
    if (p && p.bodyPartId) {
      if (
        i !== 0 &&
        this.saveProcedureList[i - 1].bodyPartId === p.bodyPartId
      ) {
        return 0;
      }
    }
    return 1;
  }

  getExamOpacityValue(i, p) {
    if (p && p.examId) {
      if (i !== 0 && this.TCProceduresList[i - 1].examId === p.examId) {
        return 0;
      }
    }
    return 1;
  }

  getBodyOpacityValue(i, p) {
    if (p && p.bodyPartId) {
      if (i !== 0 && this.TCProceduresList[i - 1].bodyPartId === p.bodyPartId) {
        return 0;
      }
    }
    return 1;
  }
}
